// extracted by mini-css-extract-plugin
module.exports = {"player_pdf_box__nodata":"styles_player_pdf_box__nodata__tuM-L"};